import { render } from "./ShopDetails.vue?vue&type=template&id=28b2271e&scoped=true&ts=true"
import script from "./ShopDetails.vue?vue&type=script&lang=ts"
export * from "./ShopDetails.vue?vue&type=script&lang=ts"

import "./ShopDetails.vue?vue&type=style&index=0&id=28b2271e&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28b2271e"]])

export default __exports__